import { BaseClient } from 'src/common-services/clients/base-client'
import { AMExtendedResults, AMSearchRequest } from 'src/common-services/types/alphamap'
import { MobilityResults, NearbyResults } from 'src/server/data/alphamap/search'

export class SearchClient extends BaseClient {
  getExtendedResultsFromPoints(request: AMSearchRequest): Promise<AMExtendedResults> {
    return this.call<AMExtendedResults>(`/search/by-points`, 'POST', {
      data: request,
    })
  }

  getNearbyResults(request: AMSearchRequest): Promise<NearbyResults> {
    return this.call<NearbyResults>(`/search/nearby`, 'POST', {
      data: request,
    })
  }

  getParcelResults(request: AMSearchRequest): Promise<MobilityResults> {
    return this.call<MobilityResults>(`/search/parcel`, 'POST', {
      data: request,
    })
  }
}
